import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import moment from "moment";
import { DatePicker } from "antd";
import "antd/dist/antd.css";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import "../../Assets/Styles/pages/dateTime.scss";
import { setItem } from "../../Redux/WaterMarks/wateramarks";
import CancelButton from "../Cancel_button/Cancel_button";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ButtonRounded from "../Signature/button";
const Datetime = ({ open, setOpen, setActive }) => {
  const { t } = useTranslation();

  const [font, setFont] = useState("Arial");
  const [color, setColor] = useState("#000000");
  const [shadowColor, setShadowColor] = useState("#000000");
  const [enableShadowColor, setEnableShadowColor] = useState("#000000");

  const [localDate, setLocalDate] = useState(5);
  const [outputDate, SetOutputDate] = useState("");
  const [momentOfDate, setMoment] = useState(moment());

  const previoiusState = useSelector((state) => state["previousSettingsSlice"]);

  const onOk = (value) => {
    setMoment(value);
  };

  const dispatch = useDispatch();

  const handleChange = (event) => {
    setLocalDate(event.target.value);
  };

  useEffect(() => {
    let intervalId;

    const updateDate = () => {
      SetOutputDate(
        momentOfDate
          ? momentOfDate.format("MMM DD,YYYY hh:mm a")
          : moment().format("MMM DD,YYYY hh:mm a")
      );
    };

    updateDate();

    intervalId = setInterval(updateDate, 60000);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [open]);

  useEffect(() => {
    let mins;
    const selectedDate = new Date();
    mins = selectedDate.getMinutes();

    if (mins < 10) mins = "0" + mins;
    if (localDate === 1)
      SetOutputDate(
        momentOfDate
          ? momentOfDate.format("MM/DD/YY hh:mm a")
          : moment().format("MM/DD/YY hh:mm a")
      );
    else if (localDate === 2)
      SetOutputDate(
        momentOfDate
          ? momentOfDate.format("DD/MM/YY hh:mm a")
          : moment().format("DD/MM/YY hh:mm a")
      );
    else if (localDate === 3)
      SetOutputDate(
        momentOfDate
          ? momentOfDate.format("DD-MM-YY hh:mm a")
          : moment().format("DD-MM-YY hh:mm a")
      );
    else if (localDate === 4)
      SetOutputDate(
        momentOfDate
          ? momentOfDate.format("MMMM DD,YYYY hh:mm a")
          : moment().format("MMMM DD,YYYY hh:mm a")
      );
    else if (localDate === 5)
      SetOutputDate(
        momentOfDate
          ? momentOfDate.format("MMM DD,YYYY hh:mm a")
          : moment().format("MMM DD,YYYY hh:mm a")
      );
    else SetOutputDate(moment());
  }, [localDate, momentOfDate]);

  useEffect(() => {
    setFont(previoiusState.textFont);
    setColor(previoiusState.textColor);
    setShadowColor(previoiusState.shadowColor);
    setEnableShadowColor(previoiusState.enableshadowColor);
  }, [previoiusState]);

  const applyDate = () => {
    if (outputDate !== "") {
      dispatch(
        setItem({
          type: "text",
          property: "date",
          id: Date.now(),
          x: 50,
          y: 50,
          deg: 0,
          scaleX: 0.07,
          scaleY: 0.07,
          src: outputDate,
          textColor: color,
          opacity: 1,
          font: font,
          shadowColor: shadowColor,
          enableShadowColor: enableShadowColor,
        })
      );
      setOpen(false);
      setActive("date");
    }
  };
  return (
    <Modal
      open={open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 800,
      }}
      onClose={() => setOpen(false)}
    >
      <Fade in={open}>
        <div className="date_model p-4">
          <CancelButton close={() => setOpen(false)} />
          <Col className="border-bottom">
            <p className="text_center productSansBold text_18 mt-0 line_height_100pc mb-0">
              {t("Date.Header")}
            </p>
            <p className="text_center productSansLight text_15  mt-2">
              {t("Date.Subtitle")}
            </p>
          </Col>
          <Col className="border-bottom">
            <p className="text_center productSansBold text_30">{outputDate}</p>
          </Col>
          <Col className="productSansLight text_15">
            <Row className="date_wrapper my-3">
              <Form.Label className="p-0">{t("Date.SelectFormat")}</Form.Label>
              <Form.Select
                className="select productSansLight text_15"
                onChange={handleChange}
              >
                <option value={1}>
                  {momentOfDate
                    ? momentOfDate.format("MM/DD/YY hh:mm a")
                    : moment().format("MM/DD/YY hh:mm a")}
                </option>
                <option value={2}>
                  {momentOfDate
                    ? momentOfDate.format("DD/MM/YY hh:mm a")
                    : moment().format("DD/MM/YY hh:mm a")}
                </option>
                <option value={3}>
                  {momentOfDate
                    ? momentOfDate.format("DD-MM-YY hh:mm a")
                    : moment().format("DD-MM-YY hh:mm a")}
                </option>
                <option value={4}>
                  {momentOfDate
                    ? momentOfDate.format("MMMM DD,YYYY hh:mm a")
                    : moment().format("MMMM DD,YYYY hh:mm a")}
                </option>
                <option selected value={5}>
                  {momentOfDate
                    ? momentOfDate.format("MMM DD,YYYY hh:mm a")
                    : moment().format("MMM DD,YYYY hh:mm a")}
                </option>
              </Form.Select>
            </Row>
            <Row className="date_wrapper productSansLight text_15">
              <Form.Label className="p-0">{t("Date.SelectDate")}</Form.Label>
              <DatePicker
                allowClear={false}
                showNow={true}
                showTime={{
                  format: "HH:mm A",
                }}
                showSecond={true}
                onOk={onOk}
                value={momentOfDate}
              />
            </Row>

            <ButtonRounded
              onclick={applyDate}
              text={"Nav.Done"}
              style={"w_edit_button  mt-4"}
            />
          </Col>
        </div>
      </Fade>
    </Modal>
  );
};

export default Datetime;
